import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

console.log("Assistência PWA versão: 1.0.2");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        console.log("Service Worker registrado com escopo:", reg.scope);

        const showUpdateToast = () => {
          import("sonner").then(({ toast }) => {
            toast.info("Nova versão disponível!", {
              description: "Clique para carregar as novidades no aplicativo.",
              duration: 20000,
              action: {
                label: "Atualizar",
                onClick: () => {
                  window.location.reload();
                }
              }
            });
          });
        };

        // Check if there is already a waiting service worker
        if (reg.waiting) {
          showUpdateToast();
        }

        // Listen for new service worker installation
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                showUpdateToast();
              }
            });
          }
        });
      })
      .catch((err) => console.error("Falha ao registrar Service Worker:", err));
  });
}

